// Datele firmei — date reale de identificare fiscală.
export const COMPANY = {
  name: "COFFEE CUP SUPPLY CO. S.R.L.",
  cui: "54667330",
  reg: "J2026031083009",
  address: "Sat Lovrin, nr. 1236, Hala 2, jud. Timiș, cod poștal 307250, România",
  email: "office@coffeecup-supply.com",
  phone: "0761 038 086",
  program: "Luni–Vineri, 09:00–18:00",
};

const UPDATED = "1 august 2026";

export const LEGAL_DOCS = {
  termeni: {
    title: "Termeni și condiții",
    subtitle: "Reguli de utilizare a magazinului online",
    updated: UPDATED,
    sections: [
      {
        h: "1. Informații generale",
        body: [
          `Website-ul coffeecup-supply.com este deținut și administrat de ${COMPANY.name}, cu sediul în ${COMPANY.address}, CUI ${COMPANY.cui}, înregistrată la Registrul Comerțului sub nr. ${COMPANY.reg} (denumită în continuare „Vânzătorul").`,
          "Prin accesarea și utilizarea acestui site, precum și prin plasarea unei comenzi, îți exprimi acordul cu privire la prezenții Termeni și condiții. Te rugăm să îi citești cu atenție.",
        ],
      },
      {
        h: "2. Produse și prețuri",
        body: [
          "Comercializăm cafea boabe și măcinată de la branduri de renume. Imaginile produselor au caracter informativ și pot diferi ușor de produsul real.",
          "Toate prețurile afișate sunt exprimate în lei (RON) și includ TVA. Vânzătorul își rezervă dreptul de a modifica prețurile fără notificare prealabilă, prețul valabil fiind cel afișat în momentul plasării comenzii.",
        ],
      },
      {
        h: "3. Comenzi",
        body: [
          "Comanda se consideră plasată în momentul confirmării ei de către client, cu acceptarea prezenților Termeni. Vei primi un email de confirmare cu detaliile comenzii, care constituie și dovada achiziției.",
          "Vânzătorul poate anula o comandă, cu notificarea prealabilă a clientului, în situații precum: date incomplete/incorecte, epuizarea stocului sau imposibilitatea onorării comenzii din motive independente.",
        ],
      },
      {
        h: "4. Plată",
        body: [
          "Metodele de plată acceptate sunt: card online (procesat securizat), ramburs la livrare și transfer bancar. Detalii suplimentare găsești în pagina Livrare și plată.",
        ],
      },
      {
        h: "5. Livrare",
        body: [
          "Livrarea se face prin curier la nivel național sau prin ridicare de la sediu. Termenele și costurile sunt detaliate în pagina Livrare și plată.",
        ],
      },
      {
        h: "6. Dreptul de retur",
        body: [
          "În calitate de consumator, ai dreptul de a te retrage din contract în termen de 14 zile calendaristice, conform OUG nr. 34/2014. Condițiile de retur sunt descrise în pagina Politica de retur.",
        ],
      },
      {
        h: "7. Proprietate intelectuală",
        body: [
          "Întregul conținut al site-ului (texte, imagini, logo-uri, grafică) este proprietatea Vânzătorului sau a partenerilor săi și este protejat de legislația privind drepturile de autor. Reproducerea fără acord este interzisă.",
        ],
      },
      {
        h: "8. Legislație aplicabilă",
        body: [
          "Prezenții Termeni sunt guvernați de legislația română. Eventualele litigii se soluționează pe cale amiabilă sau, în lipsa unei înțelegeri, de către instanțele competente. Vezi și pagina ANPC și soluționarea litigiilor.",
        ],
      },
    ],
  },

  confidentialitate: {
    title: "Politica de confidențialitate",
    subtitle: "Prelucrarea datelor cu caracter personal (GDPR)",
    updated: UPDATED,
    sections: [
      {
        h: "1. Operatorul de date",
        body: [
          `${COMPANY.name}, cu sediul în ${COMPANY.address}, CUI ${COMPANY.cui}, este operator de date cu caracter personal și prelucrează datele tale în conformitate cu Regulamentul (UE) 2016/679 (GDPR).`,
          `Ne poți contacta pentru orice aspect legat de datele personale la ${COMPANY.email}.`,
        ],
      },
      {
        h: "2. Ce date colectăm",
        body: [
          "Colectăm datele pe care ni le furnizezi direct: nume, prenume, adresă de email, număr de telefon, adresă de livrare și facturare, iar pentru persoane juridice: denumire firmă, CUI, nr. Reg. Comerțului.",
          "Colectăm, de asemenea, date tehnice generate automat (adresă IP, tip dispozitiv, pagini vizitate) prin cookie-uri și tehnologii similare.",
        ],
      },
      {
        h: "3. Scopul prelucrării",
        body: [
          "Procesarea și livrarea comenzilor și emiterea documentelor fiscale;",
          "Comunicarea cu tine privind comenzile și solicitările de suport;",
          "Transmiterea de comunicări comerciale (newsletter) — doar cu consimțământul tău;",
          "Îmbunătățirea serviciilor și îndeplinirea obligațiilor legale.",
        ],
      },
      {
        h: "4. Temeiul legal",
        body: [
          "Executarea contractului (procesarea comenzii), consimțământul (newsletter, cookie-uri de marketing), obligația legală (documente contabile) și interesul legitim (securitate și îmbunătățirea serviciilor).",
        ],
      },
      {
        h: "5. Durata stocării",
        body: [
          "Păstrăm datele pe durata necesară îndeplinirii scopurilor, respectiv pe durata relației contractuale și ulterior conform termenelor legale (ex. documentele financiar-contabile se păstrează 10 ani).",
        ],
      },
      {
        h: "6. Drepturile tale",
        body: [
          "Ai dreptul de acces, rectificare, ștergere, restricționare, portabilitate, opoziție și dreptul de a-ți retrage consimțământul în orice moment.",
          `Îți poți exercita drepturile printr-o solicitare la ${COMPANY.email}. De asemenea, ai dreptul de a depune plângere la Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP).`,
        ],
      },
      {
        h: "7. Destinatarii datelor",
        body: [
          "Putem transmite date către parteneri de încredere strict pentru îndeplinirea comenzii: firme de curierat, procesatori de plăți și furnizori de servicii IT/email, în baza unor acorduri de confidențialitate.",
        ],
      },
    ],
  },

  cookies: {
    title: "Politica de cookies",
    subtitle: "Cum folosim cookie-urile pe acest site",
    updated: UPDATED,
    sections: [
      {
        h: "1. Ce sunt cookie-urile",
        body: [
          "Cookie-urile sunt fișiere text de mici dimensiuni stocate pe dispozitivul tău atunci când vizitezi un website. Ele ajută site-ul să funcționeze corect și să rețină preferințele tale.",
        ],
      },
      {
        h: "2. Tipuri de cookie-uri utilizate",
        body: [
          "Cookie-uri strict necesare — esențiale pentru funcționarea site-ului (autentificare, coș de cumpărături). Fără acestea site-ul nu poate funcționa.",
          "Cookie-uri de preferințe — rețin opțiuni precum limba sau produsele vizualizate recent.",
          "Cookie-uri de analiză — ne ajută să înțelegem cum este utilizat site-ul, pentru a-l îmbunătăți.",
        ],
      },
      {
        h: "3. Gestionarea cookie-urilor",
        body: [
          "Poți controla și șterge cookie-urile din setările browserului tău. Reține că dezactivarea cookie-urilor strict necesare poate afecta funcționarea magazinului (ex. coșul de cumpărături).",
        ],
      },
      {
        h: "4. Stocare locală",
        body: [
          "Pentru o experiență mai bună folosim și stocarea locală a browserului (localStorage) pentru a păstra coșul de cumpărături și sesiunea de autentificare.",
        ],
      },
    ],
  },

  "livrare-plata": {
    title: "Livrare și plată",
    subtitle: "Modalități, costuri și termene",
    updated: UPDATED,
    sections: [
      {
        h: "1. Modalități de livrare",
        body: [
          "Livrare prin curier — la nivel național, în 1–3 zile lucrătoare de la confirmarea comenzii.",
          "Ridicare de la sediu — gratuit, de la adresa noastră, în intervalul orar de program. Te anunțăm când comanda este pregătită.",
        ],
      },
      {
        h: "2. Costuri de transport",
        body: [
          "Costul standard de livrare prin curier este de 19,99 lei.",
          "Transportul este GRATUIT pentru comenzile de peste 200 lei și pentru ridicarea de la sediu.",
        ],
      },
      {
        h: "3. Modalități de plată",
        body: [
          "Card online — plată securizată cu cardul, procesată prin partenerul nostru de plăți.",
          "Ramburs la livrare — plătești în numerar sau cu cardul curierului, la primirea coletului.",
          "Transfer bancar — vei primi datele de facturare pentru efectuarea plății.",
        ],
      },
      {
        h: "4. Ambalare și prospețime",
        body: [
          "Toate produsele sunt ambalate sigilat pentru a păstra prospețimea și aroma cafelei pe durata transportului.",
        ],
      },
    ],
  },

  retur: {
    title: "Politica de retur",
    subtitle: "Dreptul de retragere și rambursarea",
    updated: UPDATED,
    sections: [
      {
        h: "1. Dreptul de retragere",
        body: [
          "Conform OUG nr. 34/2014, ai dreptul de a te retrage din contract în termen de 14 zile calendaristice de la primirea produselor, fără a fi nevoie să justifici decizia.",
        ],
      },
      {
        h: "2. Condiții de retur",
        body: [
          "Produsele trebuie returnate în starea în care au fost primite, cu ambalajul original nedesfăcut/nedeteriorat. Din motive de igienă și siguranță alimentară, produsele alimentare desigilate nu pot fi returnate.",
          "Te rugăm să ne anunți intenția de retur în scris, la adresa de email, menționând numărul comenzii.",
        ],
      },
      {
        h: "3. Rambursarea",
        body: [
          "Vom rambursa contravaloarea produselor returnate în cel mult 14 zile de la data la care am fost informați, folosind aceeași modalitate de plată utilizată la comandă, dacă nu ai solicitat altfel.",
          "Costul returului este suportat de client, cu excepția cazurilor în care produsul livrat a fost greșit sau defect.",
        ],
      },
      {
        h: "4. Produse neconforme",
        body: [
          "Dacă ai primit un produs greșit, deteriorat sau cu defect, te rugăm să ne contactezi imediat. Vom soluționa situația prin înlocuire sau rambursare integrală, inclusiv costurile de transport.",
        ],
      },
    ],
  },

  anpc: {
    title: "ANPC și soluționarea litigiilor",
    subtitle: "Protecția consumatorilor",
    updated: UPDATED,
    sections: [
      {
        h: "Autoritatea Națională pentru Protecția Consumatorilor",
        body: [
          "Ne dorim ca fiecare experiență de cumpărare să fie una excelentă. Dacă totuși ai o nemulțumire, te rugăm să ne contactezi întâi pe noi, pentru a găsi împreună cea mai bună soluție.",
          "În calitate de consumator, ai dreptul de a te adresa Autorității Naționale pentru Protecția Consumatorilor (ANPC).",
        ],
      },
      {
        h: "Soluționarea alternativă a litigiilor (SAL / SOL)",
        body: [
          "Poți apela la mecanismele de soluționare alternativă a litigiilor (SAL) puse la dispoziție de ANPC, precum și la platforma europeană de soluționare online a litigiilor (SOL).",
        ],
        links: [
          { label: "ANPC — Protecția consumatorilor", href: "https://anpc.ro/" },
          { label: "SAL — Soluționarea Alternativă a Litigiilor", href: "https://anpc.ro/ce-este-sal/" },
          { label: "SOL — Platforma europeană de soluționare online", href: "https://ec.europa.eu/consumers/odr" },
        ],
      },
    ],
  },
};
